"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Switch = exports.Switch = function Switch(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "button",
    role: "switch",
    tx: "switches"
  }, props, {
    __css: {
      width: '42px',
      height: '22px',
      appearance: 'none',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '2px 4px',
      borderRadius: 'circle',
      cursor: 'pointer',
      border: '1px solid #D4DBDE',
      bg: 'neutral.0',
      position: 'relative',
      outline: 'none',
      transition: 'background-color .1s cubic-bezier(.4, 0, .2, 1)',
      '&::before': {
        content: "''",
        background: '#D4DBDE',
        position: 'absolute',
        size: '16px',
        borderRadius: 'circle',
        top: '50%',
        left: 0,
        transform: 'translate(3px, -50%)',
        transition: 'transform .1s cubic-bezier(.4, 0, .2, 1)'
      },
      '&[aria-checked="true"]': {
        backgroundColor: '#6A88F2',
        '&::before': {
          transform: 'translate(21px, -50%)',
          bg: 'white'
        }
      },
      '&[disabled]': {
        bg: '#EFF2F3',
        border: 'none',
        '&::before': {
          background: '#C1CCD0',
          boxShadow: 'none'
        }
      }
    }
  }));
};